/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useCallback} from 'react'
import {Field, ErrorMessage, useField} from 'formik'
import {AnimaBaixo, AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import {useIntl} from 'react-intl'
import {useDropzone} from 'react-dropzone'
import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'

const Step2: FC = () => {
  // const [field, meta, helpers] = useField(MyDropzone)
  const [field2, ,] = useField('paid')
  const [, , helpers3] = useField('proof_payment')
  const intl = useIntl()

  const onDrop = useCallback((acceptedFiles: any) => {
    helpers3.setValue(acceptedFiles[0])
    //setActive(true)
    // eslint-disable-next-line
  }, [])

  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})
  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo>
      <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p>
    </AnimaBaixo>
  ))

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder d-flex align-items-center text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP4'})}
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Billing is issued based on your selected account type'
            ></i>
          </h2>

          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP4'})}
          </div>
        </div>

        <div className='row mb-5'>
          <div className='col-lg-12 '>
            <label className='form-label fs-6 fw-bold d-flex mb-3 required'>
              {intl.formatMessage({id: 'LICENSES.CONTROL_CONDITIONERS'})}
            </label>
            <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
              <label className='form-check-label'>
                {intl.formatMessage({id: 'COMMON.NO'})}
                &nbsp;
              </label>
              <input
                className='form-check-input w-45px h-30px'
                type='checkbox'
                id='allowmarketing'
                {...field2}
                // defaultChecked={data.allowMarketing}
                // onChange={() => {
                //   updateData({allowMarketing: !data.allowMarketing})
                // }}
              />
              <label className='form-check-label'>{intl.formatMessage({id: 'COMMON.YES'})}</label>
            </div>
          </div>
        </div>

        <div className='fv-row'>
          <div className='row'>
            <div className='col-lg-12'>
              <Field
                type='radio'
                className='btn-check'
                name='accountType'
                value='personal'
                id='kt_create_account_form_account_type_personal'
              />
            </div>

            <div className='text-danger mt-2'>
              <ErrorMessage name='accountType' />
            </div>
          </div>

          {/* inicio teste dropzone */}
          <div>
            <div className='dropzone' {...getRootProps()}>
              <div className='dz-message needsclick'>
                <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                <div className='ms-4'>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                      {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                    </h3>
                  ) : (
                    <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                      {intl.formatMessage({id: 'DROPZONE.TITLE'})}
                    </h3>
                  )}

                  <label htmlFor='license_documentation' className='fs-7 fw-semibold text-gray-400'>
                    {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                  </label>
                </div>
              </div>

              <p> {files}</p>
            </div>
          </div>
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
